import { GeneralResourceDetailYearly } from './ResourceDetail'

export const programTypes = ['county', 'state', 'federal', 'private', 'other']

export type ProgramTypes = typeof programTypes[number]

export interface RDConservationProgramsList
  extends GeneralResourceDetailYearly<{ none: boolean; programs: Record<ProgramTypes, string[]> }> {
  traitId: 'conservationPrograms'
}
